import React, { useContext } from 'react'
import {DataContext} from "../Content/Data";
import TemplateMusic from "./TemplateMusic";

export const Music1 = () => {
    const [data, setData] = useContext(DataContext);

    const addNewElement = (file) => {
        const newEl = {
            name: file.name,
            src: URL.createObjectURL(file),
            id: `drop${Math.random()}`,
            path: ''
        };

        setData({...data, Noisli: [...data.Noisli, newEl] });
    }

    return (
        <TemplateMusic
            id={'Music1'}
            data={data.Noisli}
            addNewElement={addNewElement}
        />
    )
}